/**
 * ---------------------------------------------------------------------------------------------------------------------
 * CÀI ĐẶT KIỂU HIỂN THỊ TRANG DANH SÁCH ------------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 * */
export const LAYOUT_LIST_PAGE_USE_TABLE = 1; // Hiển thị danh sách dạng table
export const LAYOUT_LIST_PAGE_USE_NODES = 2; // Hiển thị danh sách dạng nodes box


